module.exports = __webpack_public_path__ + "img/usecase02.beb81a64.png";